const MOTOR_OCR = {
  GEMINI: "Gemini",
  TRADICIONAL: "Tradicional",
};

export default MOTOR_OCR;